module.exports = __webpack_public_path__ + "static/media/shape_5.b6bf9131.png";